import React from 'react';
import { useForm } from 'react-hook-form';
import { BsInfoCircle } from 'react-icons/bs';
import { useSelector } from 'react-redux';
import { Box, Flex, HStack, Icon, IconButton, Switch, Text, Tooltip } from '@chakra-ui/react';

import { TabNames } from '../../../../../../../../../../../../constants/tabMenuTypes';
import colors from '../../../../../../../../../../../../styles/theme/foundation/colors';
import FormInput from '../../../../../../../../../../../form/FormInput';
import { requiredCustomDocumentStack } from '../formStacks';
import {inAppText} from "../../../../../../../../../../../../constants/inAppText";

function CustomDocumentTypeForm({ formId, onSubmit, blueprint }) {
  const currentEditCustomDocumentId = useSelector(blueprint.selectCurrentEditCustomDocumentId);
  const insuranceDocumentTypes = useSelector(blueprint.selectInsuranceDocumentTypes);
  const activeStep = useSelector(blueprint.selectCreateCustomStep(TabNames.Documents));

  const getEditDocumentFormDefaultValues = () => {
    const allInsuranceDocuments = [...insuranceDocumentTypes.data, ...insuranceDocumentTypes.deletedData];
    const currentDocumentTypeData = allInsuranceDocuments
      ?.filter(documentType => documentType.id === parseInt(currentEditCustomDocumentId, 10))?.[0];

    const addToList = activeStep !== 2;

    let defaultDocumentValues = {};
    defaultDocumentValues = Object.assign(
      defaultDocumentValues,
      {
        documentName: currentDocumentTypeData?.displayName,
        description: currentDocumentTypeData?.description,
        addToList
      }
    );

    return defaultDocumentValues;
  };

  const useFormMethods = useForm({ defaultValues: (currentEditCustomDocumentId || activeStep === 2)
    ? getEditDocumentFormDefaultValues()
    : { addToList: true } });
  const { handleSubmit, watch, setValue } = useFormMethods;

  return (
    <form id={formId} onSubmit={handleSubmit(onSubmit)}>
      <Box pb={2}>
        {requiredCustomDocumentStack.map(input => (
          <FormInput
            caption={input?.caption}
            inputName={input.name}
            key={input.name}
            labelName={input.label}
            required={input?.required}
            toolTip={input?.toolTip}
            type={input?.type}
            useFormMethods={useFormMethods}
            validationRules={input?.validationRules}
          />
        ))}
      </Box>
      {!currentEditCustomDocumentId && (
        <Flex justify="space-between" mt="26px">
          <HStack flexFlow="row nowrap" w="85%">
            <Text
              color={colors.greyScale['900']}
              textStyle="bodyMd500"
            >
              Save Custom Document to List
            </Text>
            <Tooltip hasArrow
                     label={inAppText.tooltips.templates.templateBuilder.createCustomDoc.saveToListToggle}>
              <IconButton
                aria-label="User Help"
                boxSize={1}
                color={colors.greyScale['900']}
                icon={<Icon as={BsInfoCircle} ml={-4} />}
                variant="textGrey"
              />
            </Tooltip>
          </HStack>
          <Box alignItems="flex-end" pr="10px" textAlign="right" w="10%">
            <Switch
              isChecked={watch('addToList')}
              name="addToList"
              size="md"
              width="40px"
              onChange={e => setValue('addToList', e.target.checked)}
            />
          </Box>
        </Flex>
      )}
    </form>
  );
}

export default CustomDocumentTypeForm;
